import MidiEffect from './MidiEffect.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class AlternateTuningEffect extends MidiEffect {
    constructor(track) {
        super('Alternate Tuning', track);
        
        this.tuningMappings = {
            0: 0.1,
            1: 0.5,
            2: 0.8,
            3: 0.9,
            4: 1.2,
            5: 1.5,
            6: 2.3,
            7: 2.9,
            8: 3.3,
            9: 4.2,
            10: 5.1,
            11: 7};
    }

    get documentation() {
        return "Maps each note (i.e. the transpose) to a different note. ";
    }
    
    output() {
        for (let i in this.triggers) {
            let duration = this.triggers[i].stepData.duration;
            let stepData = this.getStep(
                this.triggers[i].stepData,
                this.getTranspose(this.triggers[i].stepData.transpose),
                this.triggers[i].stepData.duration,
                false);

            stepData.duration = duration === null ? undefined : duration;
                                        
            this.triggers[i].stepData = stepData;
        }

        return this.triggers;
    }

    getTranspose(transpose) {
        let base = Math.floor(transpose / 12) * 12;
        transpose = transpose % 12;
        if (transpose < 0) {
            transpose = 12 + transpose;
        }
        if (transpose in this.tuningMappings) {
            return base + this.tuningMappings[transpose];
        }

        return transpose;
    }

    getJson() {
        return {
            ...super.getJson(),
            tuningMappings: this.tuningMappings,
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.tuningMappings = json.tuningMappings;
    }


    getCopy(track, ignoreId=true) {
        let effect = new AlternateTuningEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }
}

export default AlternateTuningEffect;
